import NavMenu from "components/shared/nav-menu";
import { useNavItems } from "hooks/useNavItems";

import styles from "./navigation.module.scss";

export const Navigation = () => {
  const navItems = useNavItems();

  return (
    <div className={styles.navigation} data-testid="secondary-header">
      <NavMenu navItems={navItems} />
    </div>
  );
};
